import React from 'react'

import { Button } from '@wartek-id/button-v1'
import { Dialog, DialogContent, DialogOverlay } from '@wartek-id/dialog-v1'
import { Text } from '@wartek-id/text-v1'

import { assetUrl } from 'utils/url'

interface KinerjaHarianDeleteConfirmModalProps {
  isOpen: boolean
  onClose: () => void
  onConfirm: () => void
}

export function KinerjaHarianDeleteConfirmModal({
  isOpen,
  onClose,
  onConfirm,
}: KinerjaHarianDeleteConfirmModalProps) {
  return (
    <Dialog isOpen={isOpen} autoFocus={false} size="sm" onClose={onClose}>
      <DialogOverlay />
      <DialogContent
        aria-labelledby="hapus-kinerja-harian-dialog-title"
        aria-describedby="hapus-kinerja-harian-dialog-description"
      >
        <div className="p-6 space-y-4">
          <img
            src={assetUrl('/illustrations/img-notification-document.png')}
            alt=""
            width={84}
            height={84}
          />

          <Text
            variant="display-sm"
            as="h2"
            id="hapus-kinerja-harian-dialog-title"
          >
            Konfirmasi untuk Hapus Kinerja Harian
          </Text>

          <Text
            variant="eyebrow-lg"
            color="subdued"
            id="hapus-kinerja-harian-dialog-description"
          >
            Catatan kinerja Anda pada tanggal ini akan dihapus dan perlu Anda
            catat ulang.
          </Text>

          <div className="flex space-x-3 pt-4">
            <Button color="white" size="lg" onClick={onClose}>
              Kembali
            </Button>
            <Button color="black" size="lg" type="button" onClick={onConfirm}>
              Konfirmasi
            </Button>
          </div>
        </div>
      </DialogContent>
    </Dialog>
  )
}
